import { StampIcon } from '@common/icons/StampIcon';
import { ComponentType, Icon, IconName, Tooltip } from '@gcl/react-core';
import { ReactElement } from 'react';
import './DetailPageRightMenu.scss';
import { createTableLinkWithOpenNewTabElement } from '@common/tableColumn.services';
import { DownloadFile } from '@file/DownloadFile';
import { useProjectId } from '@config/config.hooks';
import { EProjectFileCategory } from '@file/projectFile/projectFile.models';
import {
  ERightMenuItemType,
  ETemporaryWorksFormsItemDataStatus,
  IDetailPageRightMenuTemporaryWorksFormsItemData,
} from './detailPageRightMenuTemporaryWorksForms.models';

interface IDetailPageRightMenuTemporaryWorksFormsItemDataProps {
  data: IDetailPageRightMenuTemporaryWorksFormsItemData;
  onClickData?: (data: IDetailPageRightMenuTemporaryWorksFormsItemData) => string;
  itemType: ERightMenuItemType;
}
export const DetailPageRightMenuTemporaryWorksFormsItemData = ({
  data,
  onClickData,
  itemType,
}: IDetailPageRightMenuTemporaryWorksFormsItemDataProps) => {
  const projectId = useProjectId();

  let statusElement: ReactElement | undefined;

  const createIcon = (iconName: IconName, className: string, tooltip: string, type?: ComponentType) => {
    return (
      <Tooltip placement="top" overlay={tooltip}>
        <Icon
          iconName={iconName}
          componentType={type || ComponentType.Secondary}
          size={16}
          className={`gcl-gems-detail-right-menu-temp-work-forms-item gcl-gems-status-icon ${className || ''}`}
        />
      </Tooltip>
    );
  };

  const createLabel = (label: string, className: string) => {
    return (
      <span className={`gcl-gems-detail-right-menu-temp-work-forms-item gcl-gems-status-label ${className || ''}`}>
        {label}
      </span>
    );
  };

  switch (data.status) {
    case ETemporaryWorksFormsItemDataStatus.DRAFT:
      statusElement = createIcon('PencilSquare', 'draft', 'Draft');
      break;
    case ETemporaryWorksFormsItemDataStatus.CANCEL:
      statusElement = createIcon('XCircle', 'cancel', 'Cancel', ComponentType.Danger);
      break;
    case ETemporaryWorksFormsItemDataStatus.COMPLETE:
      statusElement = createIcon('CheckLg', 'complete', 'Complete', ComponentType.Success);
      break;
    case ETemporaryWorksFormsItemDataStatus.SRP:
      statusElement = createLabel('SRP', 'srp');
      break;
    case ETemporaryWorksFormsItemDataStatus.TWC:
      statusElement = createLabel('TWC', 'twc');
      break;
    case ETemporaryWorksFormsItemDataStatus.ICE:
      statusElement = createLabel('ICE', 'ice');
      break;
    case ETemporaryWorksFormsItemDataStatus.TWD:
      statusElement = createLabel('TWD', 'twd');
      break;
    case ETemporaryWorksFormsItemDataStatus.PM:
      statusElement = createLabel('PM', 'pm');
      break;
    case ETemporaryWorksFormsItemDataStatus.COMPLETE_SRP:
      statusElement = (
        <>
          {createIcon('CheckLg', 'complete', 'Complete', ComponentType.Success)}
          {createLabel('SRP', 'srp')}
        </>
      );
      break;
    case ETemporaryWorksFormsItemDataStatus.COMPLETE_REMOVAL_REQUIRED:
      statusElement = (
        <>
          {createIcon('CheckLg', 'complete', 'Complete', ComponentType.Success)}
          {createIcon('CheckLg', 'complete', 'Complete', ComponentType.Success)}
        </>
      );
      break;
    case ETemporaryWorksFormsItemDataStatus.COMPLETE_CHOP:
      statusElement = (
        <>
          {createIcon('CheckLg', 'complete', 'Complete', ComponentType.Success)}
          <StampIcon size={16} />
        </>
      );
      break;
    case ETemporaryWorksFormsItemDataStatus.CHOP:
      statusElement = <StampIcon size={16} />;
      break;
    default:
      statusElement = undefined;
      break;
  }
  let Content = null;
  switch (itemType) {
    case ERightMenuItemType.DOWNLOAD:
      Content = (
        <DownloadFile
          attachmentId={data?.projectFile?.id as number}
          projectId={projectId}
          type={EProjectFileCategory.attachments}
          render={({ onClickDownloadFile }) => (
            <div onClick={onClickDownloadFile} className="gcl-mr-xs gcl-clickable gcl-fl-md">
              {data.title}
            </div>
          )}
        />
      );
      break;
    default:
      // eslint-disable-next-line no-case-declarations
      const linkUrl = onClickData ? onClickData(data) : undefined;
      Content = createTableLinkWithOpenNewTabElement({
        linkUrl: linkUrl as string,
        linkDisplay: data.title as string,
      });
      break;
  }
  return (
    <div className="gcl-gems-detail-right-menu-temp-work-forms-item-data-container">
      <div className="gcl-gems-detail-right-menu-temp-work-forms-item-data-link-container">{Content}</div>
      <div className="gcl-gems-detail-right-menu-temp-work-forms-item-data-status-container">{statusElement}</div>
    </div>
  );
};
